import classNames from "classnames/bind";
import dayjs from "dayjs";
import { ResolvedReview, ResolvedReviews } from "resolvers/data/trustpilotResolver";
import styles from "./ReviewsContainer.module.scss";
import ReviewsWrapper from "./ReviewsWrapper";

export interface ReviewsContainerProps {
    reviews: {
        trustpilot: ResolvedReviews;
    };
}

export interface NormalizedReviews {
    [key: string]: ResolvedReview[];
}

const cx = classNames.bind(styles);

const ReviewsContainer = ({ reviews }: ReviewsContainerProps) => {
    const normalizedReviews: NormalizedReviews = reviews.trustpilot.reviews
        .sort((a, b) => (dayjs(b.date) as any) - (dayjs(a.date) as any))
        .reduce((result, item) => {
            const date = dayjs(item.date).format("ddd MMM DD YYYY");
            return {
                ...result,
                [date]: [...(result[date] || []), item],
            };
        }, {} as NormalizedReviews);

    const reviewsElements = [];

    for (const val in normalizedReviews) {
        reviewsElements.push(
            <ReviewsWrapper date={val} reviews={normalizedReviews[val]} key={val} />
        );
    }

    return <div className={cx("container")}>{reviewsElements}</div>;
};

export default ReviewsContainer;
